import React, { useEffect, useCallback } from "react";
import { Grid, Link } from "@mui/material";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
import AddNewQuotes from "../../../../Components/Broker/Quotes/AddNewQuotes/AddNewQuotes";
import AddQuotes from "../../../../Components/Broker/Quotes/AddQuotesSP/AddQuotes";
import { useNavigate } from "react-router-dom";
import SelectFeature from "./SelectFeature/SelectFeature";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";
// import AddQuotes from "../../../../Components/Broker/Quotes/AddQuotes/AddQuotes";

interface Props {
  addQuoteStatus: boolean;
}

const Quotes: React.FC<Props> = ({ addQuoteStatus }) => {
  const [addQuotes, setAddQuotes] = React.useState(addQuoteStatus);
  const [quotesArchiveListStatus, setQuotesArchiveListStatus] =
    React.useState("quotes");
  const [editQuotes, setEditQuotes] = React.useState(false);
  const navigate = useNavigate();

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "quote_id",
      headerName: "Quote ID",
      flex: 2,
      minWidth: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/QuoteDetails");
            }}
          >
            {row.quote_id}
          </p>
        );
      },
    },
    {
      field: "client_name",
      headerName: "Company Name",
      flex: 4,
      minWidth: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/ClientDetails");
            }}
          >
            {row.client_name}
          </p>
        );
      },
    },
    {
      field: "industry_type",
      headerName: "Industry",
      flex: 8,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "subindustry_type",
      headerName: "Sub Industry",
      flex: 8,
      minWidth: 200,
      check_status: true,
    },
    // {
    //   field: "plan_type",
    //   headerName: "Plan Type",
    //   flex: 8,
    //   minWidth: 200,
    //   check_status: true,
    // },
    {
      field: "coverage_type",
      headerName: "Coverage Type",
      flex: 8,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "contact",
      headerName: "Contact",
      flex: 8,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 8,
      minWidth: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={"mailto:" + row.email} underline="none">
            {row.email}
          </Link>
        );
      },
    },
    {
      field: "website",
      headerName: "Website",
      flex: 8,
      minWidth: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={row.website} target="_blank" underline="none">
            {row.website}
          </Link>
        );
      },
    },
    {
      field: "city_country",
      headerName: "City - Country",
      flex: 8,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "product",
      headerName: "Product Name",
      flex: 3,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "generation_date",
      headerName: "Generation Date",
      flex: 3,
      minWidth: 120,
      check_status: true,
    },
    {
      field: "noofemployees",
      headerName: "No. of Employees",
      flex: 1,
      minWidth: 140,
      check_status: true,
    },
    // {
    //   field: "dependents",
    //   headerName: "Dependents Covered",
    //   flex: 1,
    //   minWidth: 150,
    //   check_status: true,
    // },
    {
      field: "nod",
      headerName: "No. of Lives",
      flex: 1,
      minWidth: 140,
      check_status: true,
    },
    {
      field: "sum_insured",
      headerName: "Sum Insured/Assured",
      flex: 2,
      minWidth: 160,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      flex: 1,
      minWidth: 300,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "features",
      headerName: "Features",
      flex: 1,
      minWidth: 100,
      check_status: true,
    },
    {
      field: "premium",
      headerName: "Premium Amount",
      flex: 1,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "branch_location",
      headerName: "Branch Location",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      quote_id: "EV234234234",
      client_name: "Evervent Pvt. Ltd.",
      industry_type: "IT",
      subindustry_type: "Information Technology",

      coverage_type: "Yes",
      contact: "+91-9876543210",
      email: "example@domain.com",
      website: "www.example.com",
      city_country: " Mohali - India",
      product: "Group Health Insurance",
      noofemployees: "4,456",
      generation_date: "01/01/2022",
      dependents: "Yes",
      nod: "1,005",
      sum_insured: "₹2L, ₹3L, ₹5L",
      insurer:
        "Kotak Mahindra General Insurance Co Ltd, Royal Sundaram General Insurance Co Ltd, HDFC ERGO General Insurance Co Ltd",
      status: "Pending",
      features: "5",
      premium: "₹ 2 Lakh",
      branch_location: "Mumbai",
    },
    {
      id: 1,
      quote_id: "EV234234235",
      client_name: "Quickbima Pvt. Ltd.",
      industry_type: "IT",
      subindustry_type: "Information Technology",

      coverage_type: "No",
      contact: "+91-9876543210",
      email: "example@domain.com",
      website: "www.example.com",
      city_country: " Karnal - India",
      product: "Group Health Insurance",
      noofemployees: "2,098",
      generation_date: "01/01/2022",
      dependents: "Yes",
      nod: "508",
      sum_insured: "₹2L, ₹3L, ₹5L",
      insurer:
        "Kotak Mahindra General Insurance Co Ltd, Royal Sundaram General Insurance Co Ltd, HDFC ERGO General Insurance Co Ltd",
      status: "Pending",
      features: "5",
      premium: "₹ 5 Lakh",
      branch_location: "Delhi",
    },
  ];

  useEffect(() => {
    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey && event.keyCode == 81) {
        setAddQuotes(true);
      }
    }
  }, []);

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  return (
    <Grid container spacing={2}>
      {/* Edit new contact */}
      <SelectFeature
        open_status={editQuotes}
        attrName={setEditQuotes}
        value_update={updateMasterState}
      />
      {/* Add New policy popup */}
      {/* <AddQuotes
        open_status={addQuotes}
        attrName={setAddQuotes}
        value_update={updateMasterState}
      /> */}

      {/* addQuotes sliding panel */}
      {/* <AddQuotes
        open_status={addQuotes}
        attrName={setAddQuotes}
        value_update={updateMasterState}
      /> */}

      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">
          {quotesArchiveListStatus == "quotes" ? "" : "Archived "} Quotes
        </h3>
        <SearchBox />
      </Grid>
      <Grid item xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        <Link
          underline="none"
          className="blueBtn edit"
          onClick={() => {
            navigate("/AddNewQuotes");
          }}
        >
          Edit
        </Link>
        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            // setAddQuotes(true);
            navigate("/AddNewQuotes");
          }}
        >
          Add New Quote
        </Link>
      </Grid>

      {/* Data Table */}
      <Grid item xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Quotes;
